import React, { Fragment, useMemo } from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import { DATE_FORMATS } from 'constants/index';

import { createDate, getFormattedDateRange } from 'utils/date';
import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import classes from './Entirety.module.scss';

const Entirety = ({ production, isCondensedView, isFeaturedCard }) => {
  const { isMobile } = useDeviceTypeLayouts();
  const { minDate, maxDate, isCancelled } = production || {};
  const { rangeStart, rangeEnd, separator, fromISO, toISO } = useMemo(
    () =>
      getFormattedDateRange({
        from: minDate,
        to: maxDate || minDate,
        asParts: true,
        dateFormat: DATE_FORMATS.DAY_MONTH,
      }),
    [maxDate, minDate],
  );

  const startYear = createDate(fromISO).format('YYYY');
  const endYear = toISO ? createDate(toISO).format('YYYY') : null;

  if (isCondensedView) {
    return (
      <Typography size={12} color="secondary" className={classes.condensedEntirety}>
        <time className="dt-start" dateTime={fromISO}>
          {rangeStart}
        </time>{' '}
        {separator?.trim()}{' '}
        {rangeEnd && (
          <time className="dt-end" dateTime={toISO}>
            {rangeEnd}
          </time>
        )}
        <Typography size={12} className={classes.condensedEntirety__year} color="secondary">
          <time dateTime={fromISO}>{startYear}</time>
          {endYear !== startYear && (
            <>
              {endYear && ' - '}
              {endYear && <time dateTime={fromISO}>{endYear}</time>}
            </>
          )}
        </Typography>
      </Typography>
    );
  }

  if (isMobile) {
    return (
      <Typography size={12} className={classes.entiretyMobile} weight="bold">
        <Typography
          className={classes.entiretyMobile__date}
          size={12}
          {...(isCancelled && { strikethrough: true })}
          weight="bold"
        >
          <time dateTime={fromISO}>{startYear}</time>
          {endYear !== startYear && (
            <>
              {endYear && ' - '}
              {endYear && <time dateTime={fromISO}>{endYear}</time>}
            </>
          )}
        </Typography>
        <Typography
          size={12}
          weight="bold"
          {...(isCancelled && { strikethrough: true })}
          className={classes.rangeDates}
        >
          <time className="dt-start" dateTime={fromISO}>
            {rangeStart}
          </time>{' '}
          {separator?.trim()}{' '}
          {rangeEnd && (
            <time className="dt-end" dateTime={toISO}>
              {rangeEnd}
            </time>
          )}
        </Typography>
      </Typography>
    );
  }

  return (
    <Typography
      size={12}
      className={classnames(classes.entirety, {
        [classes.entiretyFeaturedCard]: isFeaturedCard,
      })}
    >
      <Typography
        className={classnames(classes.date, {
          [classes.dateFeaturedCard]: isFeaturedCard,
        })}
        size={12}
        weight="bold"
        {...(isCancelled && { strikethrough: true })}
        truncate
      >
        <time dateTime={fromISO}>{startYear}</time>
        {endYear !== startYear && (
          <>
            {endYear && ' - '}
            {endYear && <time dateTime={fromISO}>{endYear}</time>}
          </>
        )}
      </Typography>
      <Typography
        size={12}
        color="secondary"
        weight="bold"
        {...(isCancelled && { strikethrough: true })}
        className={classes.rangeDates}
      >
        <time className="dt-start" dateTime={fromISO}>
          {rangeStart}
        </time>{' '}
        {separator?.trim()}{' '}
        {rangeEnd && (
          <time className="dt-end" dateTime={toISO}>
            {rangeEnd}
          </time>
        )}
      </Typography>
    </Typography>
  );
};

export default Entirety;
